import React from 'react'
import Footer from '../components/Footer/Footer'
import './pagestyles/Podcast.css'

function Podcast() {
  const episodes = [
    {
      id: 'aU3LUeojUOI',
      title: 'Time:less with Kushim',
      subtitle: '',
      description: '',
    },
    {
      id: 'NA6WaFDx0VU',
      title: 'Namibian Creatives For Jesus. (Timeless, E4)',
      subtitle: 'Ft Gr8Ful Podcast',
      description:
        'A collaborative episode centered on creative excellence, spiritual purpose, and the power of storytelling to build community and influence the next generation.',
    },
    {
      id: 'HSeXRl2zbmI',
      title: 'African Education & Creativity: Why It Matters (Time:less, E3)',
      subtitle: 'Why education and imagination belong together',
      description:
        'This episode explores the value of African education, imagination, and innovation, especially when they are anchored in identity, truth, and lasting impact.',
    },
    {
      id: 'kyQfcZRjjis',
      title: 'Dear Christian, you are not alone. (Time:less, E2)',
      subtitle: 'A gentle reminder of hope and belonging',
      description:
        'A heartfelt episode for anyone carrying heaviness, loneliness, or uncertainty. It invites listeners to remember that faith is not meant to be carried alone.',
    },
    {
      id: 'o2po9C9hsxk',
      title: 'The Art of Godly Content (Time:less, E1)',
      subtitle: 'Creating with purpose and conviction',
      description:
        'The opening episode of the series introducing the heart behind Time:less and the importance of building content that is meaningful, truthful, and spiritually grounded.',
    },
  ]

  return (
    <div className='podcastPage'>
      <div className='podcastHero'>
        <div className='podcastHeroContent'>
          <span className='podcastEyebrow'>Podcast • YouTube</span>
          <h1>Time:less with Kushim</h1>
          <p>Healing & Revelation Truth 🪴<br />Where Kingdom principles meets practical application. Living a kingdom life of impact.</p>
        </div>
      </div>

      <div className='podcastPageContent'>
        <div className='podcastFeatured'>
          <div className='podcastFeaturedVideo'>
            <iframe
              src={`https://www.youtube.com/embed/${episodes[0].id}`}
              title={episodes[0].title}
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen
              loading='lazy'
            />
          </div>

          <div className='podcastFeaturedText'>
            <h2>{episodes[0].title}</h2>
          </div>
        </div>

        <div className='podcastGrid'>
          {episodes.slice(1).map(({ id, title, subtitle, description }) => (
            <article className='podcastCard' key={id}>
              <div className='podcastVideoWrap'>
                <iframe
                  src={`https://www.youtube.com/embed/${id}`}
                  title={title}
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  allowFullScreen
                  loading='lazy'
                />
              </div>

              <div className='podcastCardText'>
                <h3>{title}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Podcast
